/**
 * BuyMoreCreditsButton
 *
 * Header CTA that appears to the LEFT of the billing account switcher when the user's
 * PERSONAL credit balance runs low (see usePersonalCreditLow for the exact
 * rule: keyed off owned credits with hysteresis to avoid flicker). It links to
 * the personal billing settings page, which hosts the top-up shop.
 *
 * Self-gating: renders null when the balance is healthy, so the header layout
 * carries no conditional logic. Personal credits only — org balances do not
 * trigger it.
 */
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CoinIcon } from "@/components/icons/CoinIcon";
import { routes } from "@/routes";
import { usePersonalCreditLow } from "@/hooks/usePersonalCreditLow";

export function BuyMoreCreditsButton() {
  const { t } = useTranslation();
  const { isLow } = usePersonalCreditLow();

  if (!isLow) return null;

  const label = t("settings.billing.buyMoreCredits", {
    defaultValue: "Buy more credits",
  });

  return (
    <Button asChild variant="blue" size="sm">
      <Link to={routes.settings("billing")}>
        <CoinIcon className="h-4 w-4" aria-hidden="true" />
        {label}
      </Link>
    </Button>
  );
}
